import React from 'react';
import styled from '@emotion/styled';
import TableContext from './TableContext';

const Component = styled.thead``;

const table = {
  variant: 'head',
};

const TableHead: React.FunctionComponent = (props) => {
  return (
    <TableContext.Provider value={table}>
      <Component {...props} />
    </TableContext.Provider>
  );
};

export default TableHead;
